/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskV2 } from './taskV2';
import { UpgradeSummary } from './upgradeSummary';


export interface UpgradeResponseSpec { 
    summary: UpgradeSummary;
    /**
     * Upgrade task to track the upgrade progress.
     */
    tasks?: Array<TaskV2>;
}

